import { render } from "./TaskGroupItem.vue?vue&type=template&id=761986ba"
import script from "./TaskGroupItem.vue?vue&type=script&lang=js"
export * from "./TaskGroupItem.vue?vue&type=script&lang=js"

import "./TaskGroupItem.vue?vue&type=style&index=0&id=761986ba&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__